import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';

export const displayPriceQuestions = [
  BudgetQuestionCodes.Q14,
  BudgetQuestionCodes.Q27,
  BudgetQuestionCodes.Q29,
  BudgetQuestionCodes.Q30,
];
